import {
  GREATER_THAN_TODAY_MESSAGE,
  requiredDate,
  REQUIRED_MESSAGE,
} from '@wyz/utils';
import { z } from 'zod';

export const CONTAINER_TYPES = {
  TRUCK: 'TRUCK',
  CONTAINER: 'CONTAINER',
} as const;

export const CONTAINER_ORDER_STATUS = {
  SENT_TO_SUPPLIER: 'SENT_TO_SUPPLIER',
  IN_DELIVERY: 'IN_DELIVERY',
  DELIVERED: 'DELIVERED',
  ACCEPTED_BY_SUPPLIER: 'ACCEPTED_BY_SUPPLIER',
  REJECTED_BY_SUPPLIER: 'REJECTED_BY_SUPPLIER',
} as const;

export const TRANSPORT_ITEM_STATUS = {
  SENT_TO_SUPPLIER: 'SENT_TO_SUPPLIER',
  IN_DELIVERY: 'IN_DELIVERY',
  DELIVERED: 'DELIVERED',
  ACCEPTED_BY_SUPPLIER: 'ACCEPTED_BY_SUPPLIER',
  REJECTED_BY_SUPPLIER: 'REJECTED_BY_SUPPLIER',
} as const;

export const transportItemFormSchema = z.object({
  reference: z.string().optional(),
  // greater than today
  deliveryDate: requiredDate.superRefine((date, ctx) => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    if (date < today) {
      ctx.addIssue({
        code: 'custom',
        message: GREATER_THAN_TODAY_MESSAGE,
        fatal: true,
      });
    }
  }),
  status: z.enum(TRANSPORT_ITEM_STATUS),
});

export const importTransportItemSchema = z.object({
  file: z.instanceof(File, { error: REQUIRED_MESSAGE }),
});

export const pricingTransportItemSchema = z.object({
  eans: z.array(
    z.object({
      ean: z.string(),
      price: z.number().min(0),
    }),
  ),
});
